// TODO refactor when refactor jump
export const createNavigationUrl = (path: string) => {
    return "/_/" + path;
};
